import UIImage from './ui-image.vue'
import UItable from './ui-table.vue'
import UIselect from './ui-select.vue'
import UIdialog from './ui-dialog.vue'


export default {
    install: (Vue) => {
        Vue.component('ui-image', UIImage)
        Vue.component('ui-table', UItable)
        Vue.component('ui-select', UIselect)
        Vue.component('ui-dialog', UIdialog)
    }
}
